"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _AbstractIcon = _interopRequireDefault(require("../AbstractIcon"));
var _icons = _interopRequireDefault(require("../../icons/icons.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } //components
//known icons
var IconComponent = function IconComponent(props) {
  return /*#__PURE__*/_react["default"].createElement(_AbstractIcon["default"], _extends({}, props, {
    icons: _icons["default"]
  }));
};
IconComponent.propTypes = {
  name: _propTypes["default"].oneOf(Object.keys(_icons["default"]))
};
var _default = exports["default"] = IconComponent;
//# sourceMappingURL=index.js.map